import { render } from "./DateOfBirthForm.vue?vue&type=template&id=8338396a&scoped=true"
import script from "./DateOfBirthForm.vue?vue&type=script&lang=js"
export * from "./DateOfBirthForm.vue?vue&type=script&lang=js"

import "./DateOfBirthForm.vue?vue&type=style&index=0&id=8338396a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8338396a"]])

export default __exports__